import { createWorkbookPdf } from './pdfExport';

export function appendReportSummary(sheet, { labelColumns, productColumn, productCount, numericColumns }) {
  const lastDataRow = sheet.rowCount;
  const values = Array(sheet.columnCount).fill(null);
  values[0] = 'TOTAL SUMMARY';
  numericColumns.forEach(column => {
    let total = 0;
    for (let index = 2; index <= lastDataRow; index += 1) {
      const cell = sheet.getCell(index, column);
      if (!cell.isMerged || cell.master === cell) total += Number(cell.value) || 0;
    }
    values[column - 1] = Number(total.toFixed(6));
  });
  values[productColumn - 1] = productCount;
  const row = sheet.addRow(values);
  sheet.mergeCells(row.number, 1, row.number, labelColumns);
  row.height = sheet.getRow(1).height;
  row.eachCell(cell => {
    const headerCell = sheet.getCell(1, cell.col);
    cell.fill = headerCell.fill;
    cell.font = { ...headerCell.font, bold: true };
    cell.border = headerCell.border;
    cell.alignment = { ...cell.alignment, vertical: 'middle', horizontal: 'left' };
  });
  return row;
}

export function styleRecordSheet(sheet, { numericColumns = new Set(), centeredColumns = new Set(), wrapColumns = new Set() } = {}) {
  sheet.eachRow((row, rowNumber) => {
    const isHeader = rowNumber === 1;
    row.height = isHeader ? 24 : 20;
    for (let column = 1; column <= sheet.columnCount; column += 1) {
      const cell = row.getCell(column);
      cell.font = { name: 'Calibri', size: 11, bold: isHeader, color: { argb: 'FF17345F' } };
      cell.alignment = {
        vertical: 'middle',
        horizontal: centeredColumns.has(column) ? 'center' : 'left',
        wrapText: wrapColumns.has(column),
      };
      if (isHeader) cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE4EDF5' } };
      cell.border = Object.fromEntries(['top', 'bottom', 'left', 'right'].map(side => [side, { style: 'thin', color: { argb: 'FF000000' } }]));
      if (!isHeader && numericColumns.has(column)) cell.numFmt = Number.isInteger(Number(cell.value)) ? '#,##0' : '#,##0.##########';
    }
  });
}

export async function downloadWorkbook(workbook, filename) {
  const blob = /\.xlsx$/i.test(filename)
    ? new Blob([await workbook.xlsx.writeBuffer()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    : await createWorkbookPdf(workbook);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  try {
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    // Allow the browser to start reading the file before releasing its URL.
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}

export async function exportCustomers(rows, format = 'pdf') {
  const { default: ExcelJS } = await import('exceljs');
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('Customers', { views: [{ state: 'frozen', ySplit: 1 }] });
  sheet.columns = [
    { header: 'Customer Name', width: 38 },
    { header: 'Mobile Number', width: 24 },
    { header: 'Address', width: 65 },
  ];
  rows.forEach(item => sheet.addRow([item.name || '', item.mobile_number || '', item.address || '']));
  styleRecordSheet(sheet, { wrapColumns: new Set([3]) });
  return downloadWorkbook(workbook, `customers.${format}`);
}
